var l = /* @__PURE__ */ ((e) => (e.Small = "small", e.Large = "large", e))(l || {});
const r = Symbol("size");
export {
  l as SizesEnum,
  r as sizeInjectionKey
};
